import { Link, useNavigate, useParams } from "react-router-dom";
import { useAuth } from "../lib/useAuth";
import { Masthead } from "../components/Masthead";

export default function ClientPortalStub() {
  const { slug } = useParams();
  const { user, logout } = useAuth();
  const navigate = useNavigate();

  const handleLogout = async () => {
    await logout();
    navigate("/login", { replace: true });
  };

  return (
    <main className="page-narrow">
      <Masthead as="div" />

      <h2 style={{ fontSize: "var(--text-xl)", marginTop: "var(--space-2)", marginBottom: "var(--space-3)" }}>
        Your portal is coming soon.
      </h2>
      <p className="text-muted" style={{ lineHeight: "var(--lh-normal)" }}>
        {user ? (
          <>
            Signed in as <strong className="text-ink">{user.email}</strong>
            {slug && <> for <code style={{ fontFamily: "var(--font-mono)" }}>{slug}</code></>}.
          </>
        ) : (
          <>Not signed in.</>
        )}
      </p>
      <p className="text-muted" style={{ marginTop: "var(--space-3)", lineHeight: "var(--lh-normal)" }}>
        The client-facing knowledge base is under active construction. Your valuation analyst
        will notify you when your first record is published.
      </p>

      <div className="form-actions">
        {user ? (
          <button className="btn btn-secondary" onClick={handleLogout}>Sign out</button>
        ) : (
          <Link to="/login" className="btn btn-primary">Sign in</Link>
        )}
      </div>

      <p className="disclaim-line">
        <strong>This is not an appraisal.</strong> It is a valuation analysis for commercial real estate.
      </p>
    </main>
  );
}
